module.exports = __webpack_public_path__ + "img/037-laundry-1.020db174.svg";